import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import style from '../admin/exam/ExamResult.module.css'
import axios from 'axios'
import { baseUrl } from '../../baseUrl'

const TPTReviewExam = () => {
  const params = useParams()
  const [review, setReview] = useState([])
  const [loading,setLoading]=useState(false)

  useEffect(() => {
    setLoading(true)
    axios.get(`${baseUrl}/student/exam/review?email=${params.email}&examId=${params.examId}`)
      .then(res => {setReview(res.data);setLoading(false)})
      .catch(err => {console.log(err);setLoading(false)})
  }, [])

  return (
    <div className='mb-3'>
      <h2 className='text-center mt-2 mb-2'>TPT Exam Review</h2>
      {
        loading?
        <div className='container d-flex justify-content-center'>
          <img src="/assets/images/load-time.gif" width='50px' alt="loading"/>
        </div>
        :
        <div className={`${style.instruction} container-lg`}>
        {
          review?.answers?.map((q, i) =>
            <div className=' p-2 m-2'>
              <div className="mb-2"
                dangerouslySetInnerHTML={{
                  __html: `<span class='mr-2 fw-bold fs-6'>${i+1}.</span></&nbsp;&nbsp;<span>${q.question}</span>`,
                }}
              >
              </div> 
              <div
                className={`mb-2 d-flex ${q.attempted ? (q.isCorrect ? 'text-success' : 'text-danger') : 'text-info'}`}
                dangerouslySetInnerHTML={{
                  __html: `
                    <span>Your answer:</span>&nbsp;&nbsp;
                    <span>${q.answer ? q.answer : 'N/A'}</span>
                    `,
                }}
              ></div>
              <div className="mb-2 d-flex"
                dangerouslySetInnerHTML={{
                  __html: `<span>Correct answer:</span>&nbsp;&nbsp;<span>${q.options[q.correctAnswer-1]}</span>`,
                }}
              >
              </div>
            </div>
          )
        }
      </div>
      }
    </div>
  )
}

export default TPTReviewExam
